"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _filters = require("@/filters");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'member_card',
  cname: '会员卡片',
  icon: 't-icon-huiyuankapian',
  configName: 'c_member_card',
  type: 2,
  // 0 基础组件 1 营销组件 2工具组件
  defaultName: 'memberCard',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mediaDomain', 'mobileTheme'])), {}, {
    //背景图片
    bgImgStyle: function bgImgStyle() {
      return {
        'background-image': "url(".concat(this.bgImgUrl, ")"),
        'border-radius': this.configObj.contentStyle.val ? this.configObj.contentStyle.val + 'px' : '0'
      };
    },
    //最外层盒子的样式
    boxStyle: function boxStyle() {
      return [{
        background: "linear-gradient(".concat(this.configObj.bgColor.color[0].item, ", ").concat(this.configObj.bgColor.color[1].item, ")")
      }, {
        'border-radius': this.configObj.bgStyle.val ? this.configObj.bgStyle.val + 'px' : '0'
      }, {
        margin: this.configObj.mbConfig.val + 'px' + ' ' + this.configObj.lrConfig.val + 'px' + ' ' + 0
      }, {
        padding: this.configObj.upConfig.val + 'px' + ' ' + '10px' + ' ' + this.configObj.downConfig.val + 'px'
      }];
    },
    // 领取按钮
    btnColorStyle: function btnColorStyle() {
      return [{
        background: this.themeStyle ? this.configObj.btnColor.color[0].item : this.themeRgba,
        color: this.themeStyle ? this.configObj.itemBgColor.color[0].item : this.themeColor
      }];
    },
    // 店铺名称
    merNameColor: function merNameColor() {
      return {
        color: this.configObj.merNameColor.color[0].item
      };
    },
    // 会员文字
    memNameColor: function memNameColor() {
      return {
        color: this.configObj.memNameColor ? this.configObj.memNameColor.color[0].item : '',
        backgroundColor: 'rgba(0, 0, 0, 0.3)'
      };
    },
    // 规则文字
    rulesNameColor: function rulesNameColor() {
      return {
        color: this.configObj.rulesNameColor.color[0].item
      };
    },
    // 购物金文字
    moneyColor: function moneyColor() {
      return {
        color: this.configObj.moneyColor.color[0].item
      };
    },
    logoShow: function logoShow() {
      if (this.configObj.typeConfig.activeValue.indexOf(0) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    levelShow: function levelShow() {
      //等级
      if (this.configObj.typeConfig.activeValue.indexOf(1) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    ruleShow: function ruleShow() {
      //规则
      if (this.configObj.typeConfig.activeValue.indexOf(2) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    btnShow: function btnShow() {
      //充值按钮
      if (this.configObj.typeConfig.activeValue.indexOf(3) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    priceShow: function priceShow() {
      //购物金
      if (this.configObj.typeConfig.activeValue.indexOf(4) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    // 会员权益列表
    benefitList: function benefitList() {
      return [{
        name: '会员专享价',
        icon: '💎'
      }, {
        name: '充值赠送',
        icon: '💰'
      }, {
        name: '会员专享券',
        icon: '🎫'
      }, {
        name: '入会有礼',
        icon: '🎁'
      }];
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    },
    themeStyle: {
      handler: function handler(nVal, oVal) {
        this.configObj.btnColor.isShow = this.configObj.themeStyleConfig.tabVal;
        this.configObj.itemBgColor.isShow = this.configObj.themeStyleConfig.tabVal;
      },
      deep: true
    }
  },
  data: function data() {
    return {
      defaultConfig: {
        name: 'memberCard',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '会员卡片'
        },
        //显示内容
        typeConfig: {
          title: '展示信息',
          tabTitle: '显示内容',
          name: 'rowsNum',
          activeValue: [0, 1, 2, 3, 4, 5],
          list: [{
            val: '店铺Logo'
          }, {
            val: '会员等级'
          }, {
            val: '会员规则'
          }, {
            val: '充值按钮'
          }, {
            val: '购物金余额'
          }]
        },
        cardLogoConfig: {
          isShow: 1,
          tabTitle: '会员卡片',
          title: '图片',
          tips: '建议：710px * 250px',
          url: localStorage.getItem('mediaDomain') + '/crmebimage/presets/cardBg.png'
          // url: localStorage.getItem('mediaDomain') + '/crmebimage/perset/202412/yhq.png',
        },
        logoConfig: {
          isShow: 1,
          title: 'LOGO',
          tips: '建议：44px * 44px',
          url: require('../../images/cardLogo.png')
          // url: localStorage.getItem('mediaDomain') + '/crmebimage/perset/202412/yhq.png',
        },
        titleConfig: {
          title: '品牌名称',
          place: '请输入品牌名称',
          isShow: 1,
          max: 10,
          val: '海澜之家'
        },
        // 背景颜色
        bgColor: {
          tabTitle: '颜色设置',
          title: '背景颜色',
          isShow: 1,
          color: [{
            item: 'rgba(255, 255, 255, 1)'
          }, {
            item: 'rgba(255, 255, 255, 1)'
          }],
          default: [{
            item: 'rgba(255, 255, 255, 1)'
          }, {
            item: 'rgba(255, 255, 255, 1)'
          }]
        },
        // 颜色设置
        merNameColor: {
          tabTitle: '颜色设置',
          title: '品牌名称',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        // 颜色设置
        memNameColor: {
          title: '会员文字',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        rulesNameColor: {
          title: '规则文字',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        moneyColor: {
          title: '购物金文字',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        //色调
        themeStyleConfig: {
          title: '色调',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '跟随主题风格'
          }, {
            val: '自定义'
          }]
        },
        btnColor: {
          isShow: 0,
          title: '按钮背景',
          color: [{
            item: '#FDD9BF'
          }],
          default: [{
            item: '#FDD9BF'
          }]
        },
        itemBgColor: {
          isShow: 0,
          title: '按钮文字',
          color: [{
            item: '#C26125'
          }],
          default: [{
            item: '#C26125'
          }]
        },
        // 上间距
        upConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 10,
          min: 0,
          max: 100
        },
        // 下间距
        downConfig: {
          title: '下边距',
          val: 10,
          min: 0
        },
        // 左右间距
        lrConfig: {
          title: '左右边距',
          val: 12,
          min: 0,
          max: 25
        },
        mbConfig: {
          title: '页面间距',
          val: 10,
          min: 0
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 0,
          min: 0,
          max: 30
        },
        contentStyle: {
          title: '内容圆角',
          name: 'bgStyle',
          val: 0,
          min: 0,
          max: 30
        }
      },
      configObj: null,
      themeStyle: 0,
      themeColor: '',
      themeRgba: '',
      bgImgUrl: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
      _this.setConfig(pageData);
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      if (data) {
        this.configObj = data;
        this.themeStyle = data.themeStyleConfig.tabVal;
        this.themeColor = this.$options.filters.filterTheme(this.mobileTheme - 1);
        this.themeRgba = this.$options.filters.filterThemeRgba(this.mobileTheme - 1);
        this.bgImgUrl = this.configObj.cardLogoConfig.url;
      }
    }
  }
};